module.exports = __webpack_public_path__ + "media/images/setting/Icon9-feb673cf6b68317c9a17e2246ea3f1ca.svg";